<template>
  <div
    class="display-flex flex-row flex-items-end flex-content-between"
    style="gap: var(--spacing-2xl)"
  >
    <nav
      class="tabs size-lg"
      style="--tab-font-weight: var(--font-weight-normal)"
    >
      <button
        type="button"
        :class="tabClass('packs')"
        @click.prevent="selectTab('packs')"
      >
        <font-awesome-icon
          :icon="$v6.solid.faSwatchbook"
          size="lg"
          class="margin-right-3xs"
        />
        <span><span class="display-none tablet:display-inline">Icon </span>Packs</span>
      </button>
      <button
        type="button"
        :class="tabClass('categories')"
        @click.prevent="selectTab('categories')"
      >
        <font-awesome-icon
          :icon="$v6.solid.faFolder"
          size="lg"
          class="margin-right-3xs"
        />
        <span><span class="display-none tablet:display-inline">Icon </span>Categories</span>
      </button>
    </nav>

    <wa-select-custom
      :is-full-width="false"
      :custom-style="{
        '--input-font-weight': 'var(--font-weight-normal)',
        '--input-padding': 'var(--spacing-sm) var(--input-padding-horizontal)'
      }"
      class="size-sm margin-bottom-md"
      is-minimal
      label="Choose a version of Font Awesome"
      select-whitespace="sm"
      :options="options"
      :value="$releases.active.version"
      @change="versionChanged"
    ></wa-select-custom>
  </div>
</template>

<script>
  import { matching } from 'app/releases'

  const ALL_VERSIONS = 'All versions'

  export default {
    name: 'IconsControls',

    props: {
      selectedTab: {
        type: String,
        required: true
      }
    },

    computed: {
      options() {
        const values = [
          this.$releases.latest.v6.version,
          this.$releases.latest.v5.version,
          ALL_VERSIONS
        ]

        return values.map(v => {
          return { name: v, value: v }
        })
      }
    },

    methods: {
      tabClass(tab) {
        return ['link tab', { active: this.selectedTab === tab }]
      },

      selectTab(tab) {
        this.$emit('tab-change', tab)
      },

      versionChanged(version) {
        if (version === ALL_VERSIONS) {
          this.$emit('all-versions-selected')
        } else {
          const release = matching({ version })

          this.$emit('release-change', release)
          this.$posthog.capture('icons_landing:version_select_submit', { version: release.version })
        }
      }
    }
  }
</script>
